import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import Documentation from "./pages/documentation";
import Login from "./pages/login";
import ForgotPassword from "./pages/forgot-password";
import Signup from "./pages/signup";
import ManageUser from "./pages/manageUser";
import ManageMines from "./pages/manageMines";
import Mines from "./pages/mines";
import MolSeeker from "./pages/molseeker";
import ViewerPDB from "./pages/viewerPDB";
import CleanPDB from "./pages/cleanPDB";
import CleanPDBStorage from "./pages/cleanPDBStorage";
import DownloadPDB from "./pages/downloadPDB";
import DownloadPDBStorage from "./pages/downloadPDBStorage";
import Matisse from "./pages/matisse";
import Dashboard from "./pages/dashboard";
import CreatePipeline from "./pages/createpipeline";
import Deepsage from "./pages/deepsage";
import DeepsageStorage from "./pages/deepsageStorage";
import ProcessStatusPage from "./pages/processStatusPage";
import GraphComponent from "./pages/Graph";
import Pricing from "./pages/pricing";
import Vizit from "./pages/vizit";
import Yadamp from "./pages/yadamp";
import DeepCode from "./pages/DeepCode";
import VizitStorage from "./pages/VizitStorage";
import ExtractEdgeStorage from "./pages/extractEdgeStorage";
import ExtractEdge from "./pages/extractEdge";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { isMobile } from "react-device-detect";
import PrivateRouteComponent from "./routes/PrivateRouteComponent";
import { useAuth } from "./context/AuthContext";
import { retrieveMineData } from "./Utility/ConsumeToken/consumeToken";
import { GIDProvider } from './context/GIDContext';

const backend = isMobile ? TouchBackend : HTML5Backend;

function App() {
    const { user } = useAuth();
    const isAuthenticated = Boolean(user);
    const location = useLocation();
    const navigate = useNavigate();

    const [hasMine, setHasMine] = useState(null);
    const [mineLoading, setMineLoading] = useState(true);
    const [mineData, setMineData] = useState(null);

    useEffect(() => {
        if (isAuthenticated) {
            retrieveMineData()
                .then((response) => {
                    setMineData(response);
                    setHasMine(true);
                })
                .catch(() => {
                    setHasMine(false);
                })
                .finally(() => {
                    setMineLoading(false);
                });
        } else {
            setMineLoading(false);
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (!mineLoading && isAuthenticated && hasMine === false && location.pathname !== "/mines") {
            navigate("/mines", { replace: true });
        }
    }, [mineLoading, isAuthenticated, hasMine, location.pathname, navigate]);

    if (isAuthenticated && mineLoading) {
        return <div>Loading...</div>;
    }

    return (
        <DndProvider backend={backend}>
            <GIDProvider>
                <Routes>
                    <Route
                        path="/"
                        element={
                            isAuthenticated
                                ? <Navigate to="/dashboard" replace />
                                : <Home />
                        }
                    />
                    <Route path="/documentation" element={<Documentation />} />
                    <Route path="/pricing" element={<Pricing />} />
                   
                    <Route
                        path="/login"
                        element={
                            isAuthenticated
                                ? <Navigate to="/dashboard" replace />
                                : <Login />
                        }
                    />
                    <Route
                        path="/forgot-password"
                        element={
                            isAuthenticated
                                ? <Navigate to="/dashboard" replace />
                                : <ForgotPassword />
                        }
                    />
                    <Route
                        path="/signup"
                        element={
                            isAuthenticated
                                ? <Navigate to="/dashboard" replace />
                                : <Signup />
                        }
                    />
                    <Route
                        path="/manageuser"
                        element={
                            isAuthenticated && user?.data?.admin ?
                                <PrivateRouteComponent component={<ManageUser />} /> :
                                <Navigate to="/dashboard" replace />
                        }
                    />
                    <Route
                        path="/managemines"
                        element={
                            isAuthenticated && user?.data?.admin ?
                                <PrivateRouteComponent component={<ManageMines />} /> :
                                <Navigate to="/dashboard" replace />
                        }
                    />
                    <Route path="/mines" element={<PrivateRouteComponent component={<Mines />} />} />
                    <Route path="/dashboard" element={<PrivateRouteComponent component={<Dashboard />} />} />
                    <Route path="/createpipeline" element={<PrivateRouteComponent component={<CreatePipeline />} />} />
                    <Route path="/graph" element={<PrivateRouteComponent component={<GraphComponent />} />} />
                    <Route path="/viewerPDB" element={<PrivateRouteComponent component={<ViewerPDB />} />} />
                    <Route path="/cleanPDB" element={<PrivateRouteComponent component={<CleanPDB />} />} />
                    <Route path="/cleanPDBStorage" element={<PrivateRouteComponent component={<CleanPDBStorage />} />} />
                    <Route path="/downloadPDB" element={<PrivateRouteComponent component={<DownloadPDB />} />} />
                    <Route path="/downloadPDBStorage" element={<PrivateRouteComponent component={<DownloadPDBStorage />} />} />
                    <Route path="/matisse" element={<PrivateRouteComponent component={<Matisse />} />} />
                    <Route path="/molseeker" element={<PrivateRouteComponent component={<MolSeeker />} />} />
                    <Route path="/extractEdge" element={<PrivateRouteComponent component={<ExtractEdge />} />} />
                    <Route path="/extractEdgeStorage" element={<PrivateRouteComponent component={<ExtractEdgeStorage />} />} />
                    <Route path="/deepsage" element={<PrivateRouteComponent component={<Deepsage />} />} />
                    <Route path="/deepsageStorage" element={<PrivateRouteComponent component={<DeepsageStorage />} />} />
                    <Route path="/processStatusPage" element={<PrivateRouteComponent component={<ProcessStatusPage />} />} />
                    <Route path="/vizit" element={<PrivateRouteComponent component={<Vizit />} />} />
                    <Route path="/VizitStorage" element={<PrivateRouteComponent component={<VizitStorage />} />} />
                    <Route path="/yadamp" element={<PrivateRouteComponent component={<Yadamp />} />} />
                    <Route path="/deepcode" element={<PrivateRouteComponent component={<DeepCode />} />} />
                    
                </Routes>
            </GIDProvider>
        </DndProvider>
    );
}

export default App;
